import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: false,
  userPegs: 0,
  processingRewards: false
};

var rewardsReducer = function rewardsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.GET_REWARDS_ACTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.GET_BONUS_REWARDS_ACTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.GET_PEG_POINTS_ACTION:
      {
        var userPegs = action.userPegs;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          userPegs: userPegs
        });
      }

    case Types.RESET_PEG_POINTS_ACTION:
      {
        var _userPegs = action.userPegs;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          userPegs: _userPegs
        });
      }

    case Types.GET_RECOMMENDED_REWARDS_REDEMPTION_ACTION:
      {
        var recommendedRewardsRedemptionResponse = action.recommendedRewardsRedemptionResponse;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          recommendedRewardsRedemptionResponse: recommendedRewardsRedemptionResponse
        });
      }

    case Types.GET_REWARDS_REDEMPTION_ACTION:
      {
        var rewardsRedemptionResponse = action.rewardsRedemptionResponse;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          rewardsRedemptionResponse: rewardsRedemptionResponse
        });
      }

    case Types.GET_CUSTOM_REWARDS_REDEMPTION_ACTION:
      {
        var customRewardsRedemptionResponse = action.customRewardsRedemptionResponse;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          customRewardsRedemptionResponse: customRewardsRedemptionResponse
        });
      }

    case Types.REDEEM_REWARDS_ACTION:
      {
        var redeemedRewards = action.redeemedRewards;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          redeemedRewards: redeemedRewards
        });
      }

    case Types.RESET_REWARDS_REDEMPTION_ACTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          redeemedRewards: null,
          customRewardsRedemptionResponse: null,
          rewardsRedemptionResponse: null,
          lastCustomRewardsRequest: null,
          lastRemovedItem: null
        });
      }

    case Types.RESET_REWARDS_REDEMPTION_MODULE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          redeemedRewards: null,
          customRewardsRedemptionResponse: null,
          lastCustomRewardsRequest: null,
          lastRemovedItem: null
        });
      }

    case Types.STORE_LAST_CUSTOM_REWARDS_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          lastCustomRewardsRequest: action.customRewardsRequest
        });
      }

    case Types.STORE_LAST_REMOVED_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          lastRemovedItem: action.lastRemovedItem
        });
      }

    case Types.PROCESSING_REWARDS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          processingRewards: action.processingRewards
        });
      }

    default:
      {
        return state;
      }
  }
};

export default rewardsReducer;